import Sidebar from './SideBar.vue'
import SidebarLink from './SidebarLink.vue'

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [
    {
      name: 'Dashboard',
      icon: 'ti-panel',
      path: '/admin/home'
    },
    {
      name: 'Suivi Clients',
      icon: 'ti-panel',
      path: '/admin/suivi_clients'
    },
    {
      name: 'Suivi Actions',
      icon: 'ti-panel',
      path: '/admin/suivi_actions'
    },
    {
      name: 'Planning',
      icon: 'ti-panel',
      path: '/admin/Planning'
    },
    {
      name: 'Users',
      icon: 'ti-panel',
      path: '/admin/user'
    },
    {
      name: 'Déconnexion',
      icon: 'ti-share-alt',
      path: '/login'
    }
  ],
  displaySidebar (value) {
    this.showSidebar = value
  }
}

const SidebarPlugin = {

  install (Vue) {
    Vue.mixin({
      data () {
        return {
          sidebarStore: SidebarStore
        }
      }
    })

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get () {
        return this.$root.sidebarStore
      }
    })
    Vue.component('side-bar', Sidebar)
    Vue.component('sidebar-link', SidebarLink)
  }
}

export default SidebarPlugin
